/** @type {(html: string) => HTMLElement} */
export const fromHtml = (html) => {
	const element = document.createElement("div");
	element.innerHTML = html;
	return element.firstChild;
};
